import React from 'react'

const StdProfile = () => {
    return (
        <div>
            <h1>Student Profile</h1>
        </div>
    )
}

export default StdProfile
